export const ACTION_STATUS_INITIAL = 'initial';
export const ACTION_STATUS_SUCCESS = 'success';
export const ACTION_STATUS_FULFILLED = 'fulfilled';
export const ACTION_STATUS_ERROR = 'error';
export const ACTION_STATUS_VALIDATION_ERROR = '422';
